import React from 'react'
import Chip from '@mui/material/Chip'
import { alpha, useTheme } from '@mui/material/styles'
import { useSmartTranslation } from '../../../../generic/hooks/useSmartTranslation'
import { OPERATION_STATUS_LEGACY_KEYS, operationStatusView } from '../operationStatus'
import { hasUnreportedSlack, openIncidences } from '../operationRowFlags'
import { SystemValueChip } from '../../../../generic/systemValues/SystemValueChip'

// S444 (plan §14, 23/09) — LA CELDA DE ESTADO DE UNA OPERACIÓN, compartida por la fila de Workflow y la
// de Progress. Vivía dentro de `OperationsBlock.jsx`; sale aquí con sus mapas, sus colores y sus
// comentarios tal cual para que las dos pestañas pinten el estado con EL MISMO componente: si algún
// día cambia un rótulo o un color, cambia en las dos a la vez. Una copia acabaría discrepando.
// ⚠️ No es el «Partly reported» / «No quantity reported yet» de Progress: aquello es el estado del
// REPORTE DE CANTIDADES; esto es el estado de la OPERACIÓN. Conviven y cada uno dice lo suyo.

/**
 * La píldora del estado y, debajo, sus avisos: «nada reportado todavía» y las incidencias abiertas.
 * Recibe una fila con los nombres de N3 (`status`, `quantityDone`, los dos tiempos,
 * `openIncidenceCount`), que es de donde sale en las dos pestañas.
 */
const OperationStatusCell = ({ row }) => {
  const { t_ } = useSmartTranslation()
  const theme = useTheme()
  const statusView = operationStatusView(row.status)
  const incidencias = openIncidences(row)
  return (
    <>
      <SystemValueChip look='chip' domain='OperationStatus' value={row.status} labelKeys={OPERATION_STATUS_LEGACY_KEYS} iconKey={statusView.iconKey} testId='operation-status' />
      {/* ⚠️ LOS AVISOS ACOMPAÑAN AL ESTADO, NO LO SUSTITUYEN (RN35): la píldora de estado se pinta
          siempre y los avisos van debajo. */}
      {hasUnreportedSlack(row) && (
        <Chip
          data-testid='operation-unreported-slack'
          size='small'
          label={t_('Nothing reported yet')}
          title={t_('Within theoretical')}
          sx={{ mt: 0.5, fontWeight: 700, color: 'warning.main', backgroundColor: alpha(theme.palette.warning.main, 0.12), border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}` }}
        />
      )}
      {incidencias >= 1 && (
        <Chip
          data-testid='operation-open-incidences'
          size='small'
          label={t_('{{count}} open incidences', { count: incidencias })}
          sx={{ mt: 0.5, fontWeight: 700, color: 'error.main', backgroundColor: alpha(theme.palette.error.main, 0.12), border: `1px solid ${alpha(theme.palette.error.main, 0.3)}` }}
        />
      )}
    </>
  )
}

export default OperationStatusCell
